import { useQuery } from '@tanstack/react-query';

import useOauth from 'data/oauth/use-oauth';
import wpcom, { APIError } from 'lib/wpcom-api';

interface Me {
	ID: number;
	display_name: string;
	avatar_URL: string;
}

const getMe = ( token = '' ) => {
	return wpcom( token )
		.get<Me>( '/rest/v1.1/me' )
		.then( response => response.data );
};

export default function useMeQuery() {
	const { oauth } = useOauth();

	return useQuery<
		Me,
		APIError,
		Me
	>( {
		queryKey: [ 'me' ],
		queryFn: () => getMe( oauth.accessToken ),
	} );
}
